module.exports = __webpack_public_path__ + "static/img/033 5.1a808dc9.jpg";